'use client';

import { PrismicNextLink } from '@prismicio/next';
import { faGlobe } from '@fortawesome/pro-regular-svg-icons';

// Types
import { LocalesProps } from '../../types/display/locales';

// Services
import { onDropdownHeaderOpen } from '../../services/display/dropdown';

// Components
import { Dropdown } from '../Display/Dropdown';

export const Locales = ({ label, locales }: LocalesProps) => {
  if (locales.length === 0) {
    return null;
  }

  return (
    <Dropdown
      icon={faGlobe}
      ariaLabel={label}
      onOpen={onDropdownHeaderOpen}
      options={locales.map(({ id, url, label }) => ({
        id: `locale-selector-${id}`,
        children: <PrismicNextLink href={url}>{label}</PrismicNextLink>,
      }))}
    />
  );
};
